document.querySelectorAll('.faq-question').forEach(question => {
    question.addEventListener('click', () => {
      document.querySelectorAll('.faq-question.active').forEach(activeQuestion => {
        if (activeQuestion !== question) {
          activeQuestion.classList.remove('active');
          activeQuestion.nextElementSibling.style.maxHeight = '0';
          activeQuestion.nextElementSibling.style.padding = '0 24px';
        }
      });

      question.classList.toggle('active');
      const answer = question.nextElementSibling;
      if (question.classList.contains('active')) {
        answer.style.display = 'block'; 
        const height = answer.scrollHeight; 
        answer.style.display = ''; 
        answer.style.maxHeight = height + 'px'; 
        answer.style.padding = '0 24px';
      } else {
        answer.style.maxHeight = '0';
        answer.style.padding = '0 24px';
      }
    });
  });